/*
 * @Description: 该mixin主要使用hasIndustry与isTool
 * @LastEditors: Please set LastEditors
 * @Date: 2020-11-03 09:41:19
 */
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      hasIndustry_homeProject: state => state.homeProject
    })
  },
  data() {
    return {
      hasIndustry: true,
      isTool: false
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        const homeProject = this.hasIndustry_homeProject;
        if (homeProject && homeProject.businessType) {
          const s = {
            1: true,
            2: false,
            3: true,
            4: false,
            6: false,
            7: true,
            8: false,
            9: true,
            10: true,
            11: false
          };
          this.isTool = homeProject.businessType === 9 ? true : false;
          if (
            homeProject.businessType === 9 &&
            [1, 10].includes(homeProject.patternType)
          ) {
            this.hasIndustry = true;
            this.isTool = false;
          } else if (
            homeProject.businessType === 9 &&
            [5, 6, 11, 12].includes(homeProject.patternType)
          ) {
            this.hasIndustry = false;
          } else if (
            homeProject.businessType === 5 &&
            homeProject.projectStructureType === 1
          ) {
            this.hasIndustry = false;
          } else if (
            homeProject.businessType === 5 &&
            homeProject.projectStructureType === 3
          ) {
            this.hasIndustry = true;
          } else {
            this.hasIndustry = s[homeProject.businessType];
          }
        }
      }
    }
  }
};
